/**
 * Shared community rejection fetch, submit, and merge helpers.
 */

/**
 * @param {string} locId
 */
export async function fetchCommunityRejections(locId) {
    try {
        const response = await fetch(`/remove/${encodeURIComponent(locId)}`);
        if (!response.ok) {
            return [];
        }
        const data = await response.json();
        return Array.isArray(data.rejections) ? data.rejections : [];
    } catch {
        return [];
    }
}

/**
 * @param {string} locId
 * @param {object} payload
 */
export async function submitCommunityRejection(locId, payload) {
    const response = await fetch(`/remove/${encodeURIComponent(locId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(data.error || `Submit failed (${response.status})`);
    }

    return data.rejection;
}

/**
 * @param {object[]} rejections
 */
export function rejectionsByCandidateId(rejections) {
    const map = new Map();
    for (const row of rejections) {
        if (!row?.candidateId) {
            continue;
        }
        if (!map.has(row.candidateId)) {
            map.set(row.candidateId, []);
        }
        map.get(row.candidateId).push(row);
    }

    for (const rows of map.values()) {
        rows.sort((a, b) => String(b.submittedAt).localeCompare(String(a.submittedAt)));
    }

    return map;
}

/**
 * @param {object} candidate
 * @param {object[]} rejectionList
 */
export function applyCommunityRejectionsToCandidate(candidate, rejectionList) {
    if (!rejectionList?.length) {
        return candidate;
    }

    return {
        ...candidate,
        reviewStatus: 'rejected',
        communityRejected: true,
        communityRejections: rejectionList,
        communityRejectionCount: rejectionList.length,
    };
}

export function callSignStorageKey(locId) {
    return `pota-gridscout-callsign-${locId}`;
}
